import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';

export const GrowthBadge = ({ pct, testid }) => {
  if (pct === null || pct === undefined) {
    return <span className="inline-flex items-center gap-1 text-xs text-gray-500" data-testid={testid}><Minus className="w-3 h-3" /> sin datos del mes anterior</span>;
  }
  const up = pct >= 0;
  const Icon = up ? ArrowUpRight : ArrowDownRight;
  return (
    <span data-testid={testid}
      className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full ${up ? 'bg-emerald-500/10 text-emerald-400' : 'bg-rose-500/10 text-rose-400'}`}>
      <Icon className="w-3 h-3" /> {up ? '+' : ''}{pct}% <span className="font-normal text-gray-500">vs mes anterior</span>
    </span>
  );
};

export const KpiCard = ({ label, value, icon: Icon, accent, footer, testid, delay = 0 }) => (
  <div data-testid={testid}
    style={{ animationDelay: `${delay}ms` }}
    className="relative overflow-hidden rounded-2xl border border-white/[0.06] bg-gradient-to-b from-gray-800/80 to-gray-900 p-5 shadow-[0_8px_30px_rgba(0,0,0,0.35)] animate-[kpiIn_.5s_ease-out_both] hover:border-white/10 transition-colors">
    <div className={`absolute -top-10 -right-10 w-32 h-32 rounded-full blur-3xl opacity-20 ${accent}`} />
    <div className="flex items-start justify-between relative">
      <p className="text-[11px] uppercase tracking-[0.14em] text-gray-400 font-semibold">{label}</p>
      <div className={`w-9 h-9 rounded-xl flex items-center justify-center bg-white/5 ring-1 ring-white/10`}>
        <Icon className="w-4 h-4 text-gray-200" />
      </div>
    </div>
    <p className="relative mt-3 text-3xl font-bold text-white tabular-nums tracking-tight" data-testid={`${testid}-value`}>{value}</p>
    <div className="relative mt-3 min-h-[20px]">{footer}</div>
  </div>
);
